var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { LEAKAGE_CAUSE_DATE_WORKS_BEFORE_OPTIONS } from '@shared/constants/waterDamageConstants';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let LeakageCauseDateWorksBeforeQuestion = class LeakageCauseDateWorksBeforeQuestion extends QuestionComponent {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    updateClaim(leakageCauseDateWorksBefore) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                leakageCauseDateWorksBefore,
            },
            step: this.step,
        });
    }
    get leakageCauseDateWorksBeforeOptions() {
        return Object.values(LEAKAGE_CAUSE_DATE_WORKS_BEFORE_OPTIONS);
    }
    get panelTitle() {
        return this.$tc('claim.qualification.leakage_cause_date_works_before.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.leakage_cause_date_works_before.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.waterDamageQualification.leakageCauseDateWorksBefore) {
            return null;
        }
        const option = LEAKAGE_CAUSE_DATE_WORKS_BEFORE_OPTIONS[this.waterDamageQualification.leakageCauseDateWorksBefore];
        return option ? this.$tc(option.answerTradKey, 0) : null;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.leakageCauseDateWorksBefore) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], LeakageCauseDateWorksBeforeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], LeakageCauseDateWorksBeforeQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], LeakageCauseDateWorksBeforeQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], LeakageCauseDateWorksBeforeQuestion.prototype, "setting", void 0);
LeakageCauseDateWorksBeforeQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], LeakageCauseDateWorksBeforeQuestion);
export default LeakageCauseDateWorksBeforeQuestion;
